import {E2EPage} from '@stencil/core/testing';
import {createPage, setPageContent} from '@/tests';

async function clickOnTrigger(page: E2EPage) {
    const trigger = await page.find('joy-tooltip-trigger');
    await trigger.click();
    await page.waitForChanges();
}

describe('Tooltip - e2e', () => {
    it('should display a primary tooltip when I click on trigger element, bottom-aligned, and destroy it on click outside', async () => {
        const page = await createPage();
        await setPageContent(
            page,
            `
            <joy-tooltip-trigger event="click" position="bottom" style="margin-left: 50px;margin-top: 100px;">
                    <p slot="tooltip-trigger">I am the trigger to click</p>
                    <p slot="tooltip-content">I am the tooltip content</p>
            </joy-tooltip-trigger>
            <div class="outside">Click outside !</div>
        `,
        );

        await clickOnTrigger(page);
        const tooltip = await page.find('joy-tooltip');
        expect(await tooltip.isVisible()).toBe(true);

        const outside = await page.find('.outside');
        await outside.click();
        await page.waitForChanges();

        const hiddenTooltip = await page.find('joy-tooltip');
        expect(hiddenTooltip).toBeNull();
    });

    it('should display a secondary tooltip when I mouseenter trigger element, and destroy it when mouseout is fired', async () => {
        const page = await createPage();
        await setPageContent(
            page,
            `
            <joy-tooltip-trigger class="trigger" variant="secondary" style="margin-left: 50px;margin-top: 100px;">
                    <p slot="tooltip-trigger">I am the trigger to hover, the content is left-aligned</p>
                    <p slot="tooltip-content">I am the tooltip content</p>
            </joy-tooltip-trigger>
        `,
        );

        await page.hover('.trigger');
        await page.waitForChanges();

        const tooltip = await page.find('joy-tooltip');
        expect(await tooltip.isVisible()).toBe(true);
    });

    it('should not create nor display any tooltip as no content slot has been added', async () => {
        const page = await createPage();
        await setPageContent(
            page,
            `
            <joy-tooltip-trigger event="click" position="top">
                    <p slot="tooltip-trigger">I am the trigger to click</p>
            </joy-tooltip-trigger>
        `,
        );

        await clickOnTrigger(page);

        const tooltip = await page.find('joy-tooltip');
        expect(tooltip).toBeNull();
    });
});
